import { useEffect } from "react";

const getScreenSizeInInches = () => {
  const diagonalPixels = Math.sqrt(
    window.screen.width ** 2 + window.screen.height ** 2,
  );
  const dpi = window.devicePixelRatio * 96; // Estimate DPI (96 is default)
  return diagonalPixels / dpi; // Approximate screen size in inches
};

const adjustFontSize = () => {
  const screenSize = getScreenSizeInInches();
  let fontSize = "0.875rem"; // Default for MacBook 13"

  if (screenSize >= 24) fontSize = "1.125rem"; // Extra-large 24"+
  if (screenSize >= 32) fontSize = "1.25rem"; // Ultra-wide 32"+

  document.documentElement.style.setProperty("font-size", fontSize);
};

export const useScreenSize = () => {
  useEffect(() => {
    adjustFontSize();
    window.addEventListener("resize", adjustFontSize);
    return () => window.removeEventListener("resize", adjustFontSize);
  }, []);
};
